module.exports = __webpack_public_path__ + "assets/save.29a5d3c7.svg";